module.exports = __webpack_public_path__ + "img/login.eaa81eb5.svg";